import { BaseModel } from "sjs-base-model";
import DatiAnagraficiModel from "./DatiAnagraficiModel";
import DatiEconomiciModel from "./DatiEconomiciModel";
import DatiGiuridiciModel from "./DatiGiuridiciModel";

export default class DipendenteSPTModel extends BaseModel {
    public readonly datiAnagrafici: DatiAnagraficiModel = new DatiAnagraficiModel({});
    public readonly datiGiuridici: DatiGiuridiciModel = new DatiGiuridiciModel({});
    public readonly datiEconomici: DatiEconomiciModel = new DatiEconomiciModel({});
    public readonly variazionidatiEconomici: string = "";
    public readonly certificatiRilasciati: string = "";

    constructor(data: Partial<DipendenteSPTModel>) {
        super();

        this.update(data);
    }
}
